import { useState } from "react";
import { useParams } from "react-router-dom";
import { routes } from "consts";
import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { useToaster, getApiErrorMessage } from "utils";
import { useLandingPage, shopApi } from "api/shop";
import { LandingPageForm, LandingPageFormValues } from "./Forms/LandingPageForm";
import { PaziaBox, PaziaTabs } from "components/atoms";
import { PaziaLoader } from "components/atoms";
import { SectionsList } from "./Sections/SectionsList";

export const LandingPageEditPage = () => {
  const { landingPageId } = useParams();
  const { landingPage, isLoading, invalidate } = useLandingPage(landingPageId);
  const { showSuccess, showError } = useToaster();
  const [isSaving, setIsSaving] = useState(false);
  const [activeTab, setActiveTab] = useState<"settings" | "sections">("settings");

  const onSubmit = async (data: LandingPageFormValues) => {
    if (!landingPageId) return;
    setIsSaving(true);
    try {
      await shopApi.updateLandingPage(Number(landingPageId), data);
      showSuccess("Zaktualizowano stronę");
      invalidate();
    } catch (e) {
      showError(getApiErrorMessage(e, "Nie udało się zaktualizować strony"));
      console.error(e);
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) return <PaziaLoader position="center" />;
  if (!landingPage) return null;

  const tabs = [
    {
      name: "Ustawienia",
      active: activeTab === "settings",
      onClick: () => setActiveTab("settings"),
    },
    {
      name: "Sekcje",
      active: activeTab === "sections",
      onClick: () => setActiveTab("sections"),
    },
  ];

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[
          { title: "Sklep", path: routes.SHOP_LANDING_PAGES },
          { title: landingPage.name },
        ]}
        headerText={landingPage.name}
      />
      <PaziaBox>
        <PaziaTabs tabs={tabs} className="mb-4" />
        {activeTab === "settings" && (
          <LandingPageForm onSubmit={onSubmit} landingPage={landingPage} isLoading={isSaving} />
        )}
        {activeTab === "sections" && (
          <SectionsList landingPageId={Number(landingPageId)} sections={landingPage.sections ?? []} onUpdate={invalidate} />
        )}
      </PaziaBox>
    </PageMain>
  );
};
